import orgPlugin from '@backstage/plugin-org/alpha';
import { EntityOwnershipCard } from '@backstage/plugin-org';
import {
  IdentityCard,
  entityContentMeetingToolkit,
  entityCardOrgChart,
  entityCardTeam,
} from '@internal/backstage-plugin-hm-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

/** Replaces the default user profile card with the internal IdentityCard. */
const orgUserProfileCardOverride = orgPlugin
  .getExtension('entity-card:org/user-profile')
  .override({
    params: {
      loader: async () => <IdentityCard />,
    },
  });

/** Replaces the default ownership card with a filtered, aggregated EntityOwnershipCard. */
const orgOwnershipCardOverride = orgPlugin
  .getExtension('entity-card:org/ownership')
  .override({
    params: {
      loader: async () => (
        <EntityOwnershipCard
          entityLimit={12}
          relationAggregation="aggregated"
          entityFilterKind={[
            'API',
            'Component',
            'Resource',
            'System',
            'Template',
          ]}
        />
      ),
    },
  });

/** Bundles all Org overrides and HM-specific entity extensions into a single frontend module. */
export const orgPluginOverride = createFrontendModule({
  pluginId: 'org',
  extensions: [
    orgUserProfileCardOverride,
    orgOwnershipCardOverride,
    entityCardOrgChart,
    entityCardTeam,
    entityContentMeetingToolkit,
  ],
});
